export const ProductDetailsSection = ({ data }: any) => {
    if (!data) return null;

    return (
        <div className="py-12 px-4 container mx-auto">
            <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-1">
                    <img src={data.imageUrl} alt={data.name} className="rounded-lg shadow-lg w-full" />
                </div>
                <div className="flex-1">
                    <h2 className="text-3xl font-bold mb-4">{data.name}</h2>
                    <div className="text-2xl font-bold text-primary mb-4">{data.price}</div>
                    <p className="text-gray-600 mb-6">{data.description}</p>
                </div>
            </div>
        </div>
    );
};
